module.exports = __webpack_public_path__ + "img/page2-bg.56e38fde.png";